<template lang="pug">
div
  q-card.q-mb-lg.q-mr-lg.card.bg-blue-grey-1.shadow-2
    q-card-section
      .row
        q-img.card-img(
          spinner-color="primary"
          class="rounded-borders"
          transition="scale"
          contain
          :ratio="1" v-if="thumbnail" :src="thumbnail")
        .col.row
          .col
            .q-px-md.q-py-sm.q-gutter-sm
              .text-h6.text-weight-bold {{$langTitle(item.metadata)}}
              .text-subtitle1(v-if="item && item.metadata.works")
                | {{ restaurators(item) }}
          div
            q-btn.q-my-lg.float-right(color="primary" :to="{name: 'collection-item', params: { itemId: item.id}}") Detail
            .gt-sm.text-subtitle1.text-weight-light Vloženo {{ item.metadata.created }}
</template>

<script>
import { Component, Vue, Emit } from 'vue-property-decorator'

export default @Component({
  props: {
    item: Object
  }
})
class RestorationsListItem extends Vue {
  @Emit('selected')
  selected (item) {
    // emit to parent
    return item
  }

  restaurators (item) {
    let res = ''
    if (item.metadata.works.length > 1) {
      item.metadata.works.forEach((work) => {
        res += work.metadata.creator + ', '
      })
      return 'Restaurovali ' + res.substring(0, res.length - 2)
    } else {
      return 'Restauroval(a) ' + item.metadata.works[0].metadata.creator
    }
  }

  get thumbnail () {
    if (this.item.metadata.thumbnail) {
      return `${this.item.metadata.thumbnail.iiif}full/400,/0/default.jpg`
    }
    return ''
  }
}
</script>
<style scoped lang="stylus">
.inner
  max-width 600px
.card-img
  max-width 200px
</style>
